import { render, staticRenderFns } from "./SfBadge.vue?vue&type=template&id=6c71913f&functional=true&"
import script from "./SfBadge.vue?vue&type=script&lang=js&"
export * from "./SfBadge.vue?vue&type=script&lang=js&"
import style0 from "./SfBadge.vue?vue&type=style&index=0&id=6c71913f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports